import React from 'react'
import { Redirect } from 'react-static'
import styled from 'styled-components'

import { auth } from '../../../firebase'

const Wrapper = styled.div`
  font-family: 'Overpass', sans-serif !important;
  height: 100vh;
  padding: 4em 50px;
  background-color: ${props => props.theme.admin.info};
`

const MessageHeading = styled.p`
  justify-content: center !important;
  background-color: ${props => props.theme.admin.primary} !important;
  color: #fff;
`

const PassWord = styled.div`
  margin: 0.5em 0;
`

const Button = styled.button`
  margin-top: 1em;
  background-color: ${props => props.theme.admin.primary} !important;
  color: #fff !important;
`

export default class Login extends React.PureComponent {
  state = {
    redirectToReferrer: false,
    user: '',
    pass: '',
  }
  handleFormChange = this.handleFormChange.bind(this)
  handleKeyPress = this.handleKeyPress.bind(this)
  login = this.login.bind(this)
  redirect = this.redirect.bind(this)

  handleFormChange (e) {
    const name = e.target.name
    const value = e.target.value
    this.setState({ [name]: value })
  }

  handleKeyPress (e) {
    if (e.key == 'Enter') this.login() // eslint-disable-line
  }

  login () {
    auth.authenticate(this.state.user, this.state.pass, this.redirect)
  }

  redirect () {
    this.setState({ redirectToReferrer: true })
  }

  render () {
    const { from } = this.props.location.state || { from: { pathname: '/admin' } }
    const { redirectToReferrer, user, pass } = this.state

    if (redirectToReferrer) return <Redirect push to={from} />

    return (
      <Wrapper className="admin-page">
        <div className="columns">
          <div className="column is-6 is-offset-3">
            <div className="message">
              <MessageHeading className="message-header">Log in to Bagnall Hill</MessageHeading>
              <div className="message-body">
                <div className="control">
                  <input className="input"
                    type="text"
                    placeholder="Username"
                    value={user}
                    name="user"
                    onKeyPress={this.handleKeyPress}
                    onChange={this.handleFormChange} />
                </div>
                <PassWord className="control">
                  <input className="input"
                    type="password"
                    placeholder="Password"
                    value={pass}
                    name="pass"
                    onKeyPress={this.handleKeyPress}
                    onChange={this.handleFormChange} />
                </PassWord>
                <div className="control">
                  <Button className="button" onClick={this.login}>Log in</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/login/Login.js